export function isProviderOAuthCallbackPath(pathname = globalThis.location?.pathname ?? ''): boolean {
  const normalizedPath = pathname.replace(/\/+$/, '').toLowerCase() || '/';
  return normalizedPath === '/callback' || /^\/oauth\/[^/]+\/callback$/i.test(normalizedPath);
}

export function isProviderOAuthBackendCallbackEndpoint(url: string): boolean {
  return url.includes('/google/callback') || url.includes('/microsoft/callback');
}
